var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAeS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mail_1334310",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.462,
    height: 68.593,
    viewBox: "0 0 72.462 68.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M67.737,216.062H65.1v-2.631a4.023,4.023,0,0,0-4.019-4.018H37.456V198.969h-2.45v10.444H11.382a4.024,4.024,0,0,0-4.019,4.019v2.631H4.726A4.731,4.731,0,0,0,0,220.789v7.221a4.731,4.731,0,0,0,4.726,4.726H12.21a4.731,4.731,0,0,0,4.726-4.726v-7.222a4.731,4.731,0,0,0-4.726-4.726h-2.4v-2.631a1.57,1.57,0,0,1,1.568-1.568H35.006v4.2H32.489a4.731,4.731,0,0,0-4.726,4.726v7.221a4.731,4.731,0,0,0,4.726,4.726h7.484a4.731,4.731,0,0,0,4.726-4.726v-7.221a4.731,4.731,0,0,0-4.726-4.726H37.456v-4.2H61.08a1.57,1.57,0,0,1,1.568,1.568v2.631h-2.4a4.731,4.731,0,0,0-4.726,4.726v7.221a4.731,4.731,0,0,0,4.726,4.726h7.484a4.731,4.731,0,0,0,4.726-4.726v-7.222A4.731,4.731,0,0,0,67.737,216.062Zm-56.462,5.16a1.225,1.225,0,1,1,1.712,1.753l-4.711,4.6a1.225,1.225,0,0,1-1.712,0l-2.615-2.553a1.225,1.225,0,1,1,1.712-1.753l1.759,1.717Zm27.763,0a1.225,1.225,0,1,1,1.712,1.753l-4.711,4.6a1.224,1.224,0,0,1-1.711,0l-2.615-2.553a1.225,1.225,0,1,1,1.712-1.753l1.759,1.717Zm29.475,1.753-4.711,4.6a1.225,1.225,0,0,1-1.712,0l-2.615-2.553a1.225,1.225,0,1,1,1.711-1.753l1.759,1.717,3.855-3.763a1.225,1.225,0,0,1,1.712,1.754Zm0,0",
    transform: "translate(0 -164.143)",
    fill: "#7b7bff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M101.047,20.852,121.857,3.2A4.033,4.033,0,0,0,117.916,0H79.409a4.033,4.033,0,0,0-3.944,3.218L96.293,20.854A3.664,3.664,0,0,0,101.047,20.852Zm0,0",
    transform: "translate(-62.256)",
    fill: "#7b7bff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M86.464,49.944a1.225,1.225,0,0,1,1.752,1.713L76.892,63.24a4,4,0,0,0,2.134.615h38.507a4,4,0,0,0,2.127-.61L108.273,51.66a1.225,1.225,0,1,1,1.748-1.717l11.23,11.426a4,4,0,0,0,.306-1.54V36.242L102.248,52.62a6.108,6.108,0,0,1-7.921,0L75,36.258V59.829a4.013,4.013,0,0,0,.3,1.531Zm0,0",
    transform: "translate(-61.873 -29.899)",
    fill: "#7b7bff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAeS);
export default __webpack_public_path__ + "static/media/AE_S.f1c756dafb86196797c36bac31584703.svg";
export { ForwardRef as ReactComponent };